export default function LoadingSpinner({ text = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-base-200">
      <div className="loading loading-spinner loading-lg text-primary mb-4"></div>
      <p className="text-lg text-gray-600">{text}</p>
    </div>
  )
}